import user1 from 'assets/images/tfg-chair-logo.png';
import React from 'react';

export default function imageTemplate(data) {
  return <img className="rounded-circle header-profile-user" src={data.image || user1} alt="Header Avatar" />;
}
